import { Expose } from 'class-transformer';
import { AlcoholLockEvent } from './alcohol-lock-event';
import { VehicleReport } from './vehicle-report';

export class AlcoholLockReport extends VehicleReport {
  @Expose({ name: 'event_type' })
  eventType: AlcoholLockEvent;
}
